import { Component, ComponentFactoryResolver, OnInit, ViewChild, ViewContainerRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { PedidoService } from 'src/app/services/pedido.service';
import { ModalMensajeComponent } from '../general/modal-mensaje/modal-mensaje.component';
import { LoginService } from 'src/app/services/login.service';

@Component({
  selector: 'app-pago-ok',
  templateUrl: './pago-ok.component.html',
  styleUrls: ['./pago-ok.component.css']
})
export class PagoOkComponent implements OnInit {

  pedido: any=null;
  refModalMensaje: any = {};
  mensajeRegistro: string = "";
  registroOk: boolean = false;
  registrar: boolean = false;
  @ViewChild('modalMensaje', { read: ViewContainerRef, static: false }) entry: ViewContainerRef;


  constructor(
    private route: ActivatedRoute,
    private pedidoService: PedidoService,
    private resolver: ComponentFactoryResolver,
    private router: Router,
    private loginService: LoginService
  ) { }

  ngOnInit() {

    this.route.queryParams.subscribe(result => {
      this.registrar = result.registrar;
      this.getPedido(result.token);
    });

  }

  getPedido(token: string){

    this.pedidoService.getPedido(token).subscribe(result => {
      console.log("result",result);
      if(result.result == "ok"){
        localStorage.removeItem('carrito');
        localStorage.removeItem('direccionEntregaCarrito');
        this.pedido = result.pedido;
        console.log("pedido",this.pedido);

        if(this.registrar){

          let model: any = {
            user:{
              nombre_usuario:"",
              email:this.pedido.email_cliente,
              nombre:this.pedido.nombre_cliente,
              apellidos:this.pedido.apellidos_cliente,
              direccion:this.pedido.direccion_cliente,
              cp:this.pedido.codigo_postal_cliente,
              localidad:this.pedido.municipio_id,
              telefono:this.pedido.telefono_cliente,
              dni:this.pedido.dni_cliente,
              novedades:1
            }
          };

          this.registroOk = true;

          this.loginService.registrarse(model).subscribe(result => {
            if ((<any>result).result == "ok") {
              this.registroOk = true;

              /*let model = {
                pedido_id: this.pedido.id,
                email: this.pedido.email_cliente
              };

              this.pedidoService.asociarPedido(model).subscribe(result => {});*/

            } else if ((<any>result).result == "error") {
              this.registroOk = false;
            }
          });
        }
      }else{
        this.mostrarMensajeModal("Error", "Se ha producido un error al obtener el pedido.");
      }
    });

  }

  mostrarMensajeModal(titulo, mensaje){
    this.entry.clear();
    const factory = this.resolver.resolveComponentFactory(ModalMensajeComponent);
    this.refModalMensaje = this.entry.createComponent(factory);
    this.refModalMensaje.instance.mensaje = mensaje;
    this.refModalMensaje.instance.titulo = titulo;
    this.refModalMensaje.changeDetectorRef.detectChanges();
  }

  navegar(direccion){

    if(direccion == 'perfil'){
      this.router.navigate(['perfil'], { queryParams: { opcion: 'pedidos' } });
    }else{
      this.router.navigate([direccion]);
    }

  }

}
